import React, { useCallback, useDebugValue, useEffect, useState } from "react";
import { useStateValue } from "../../State";
import moment from "moment";
import { types } from "../../Reducers/actionTypes";
import Typography from "@mui/material/Typography";
import CareTimeCalendarSuccess from "./CareTimeCalendarSuccess/CareTimeCalendarSuccess";
import CareTimeCalendarLoading from "./CareTimeCalendarLoading/CareTimeCalendarLoading";
import CareTimeCalendarFailed from "./CareTimeCalendarFailed/CareTimeCalendarFailed";
const CareTimeCalendar = () => {
  const { actions, state } = useStateValue();

  // Caretimes state array
  const careTimes = state.caretimes.testList;

  // init date (today)
  const [initDate, setInitDate] = useState(moment());
  //focusdate to which calendar will scroll
  const [focusdate, setFocusdate] = useState(moment());
  //Start 2 weeks before initDate
  const [startDate, setStartDate] = useState(moment(initDate).add(-6, "weeks"));
  //End 6 weeks after initDate
  const [endDate, setEndDate] = useState(moment(initDate).add(6, "weeks"));
  // CareTime Day list
  const [CTBDays, setCTBDays] = useState([]);

  // Calendar state -- Initial -- Loading -- success -- failed
  const [bookingMainStatus, setBookingMainStatus] = useState("INITIAL STATE");

  const [reload, setReload] = useState(false);

  const handleFocusDay = (day) => {
    //console.log(moment(day).format("DD.MM.YYYY"));
    setInitDate(day);
    setStartDate(moment(day).add(-2, "weeks"));
    setEndDate(moment(day).add(6, "weeks"));
  };

  const handleCalendarNavClick = (day) => {
    handleFocusDay(day);
    setBookingMainStatus("INITIAL STATE");
  };

  //First load CareTime data from backend and set the state accordingly. Added also to get overtime bool to display in bottom nav
  useEffect(() => {
    if (bookingMainStatus === "INITIAL STATE") {
      actions.triggerLoadCareTimes({ date: startDate, date2: endDate });
    }
  }, [bookingMainStatus]);

  useEffect(() => {
    switch (careTimes.state) {
      case undefined:
        break;
      case types.LOADING_CARETIMES:
        setBookingMainStatus("CARE_TIME_BOOKING_LOADING");
        break;
      case types.CARETIMES_LOAD_OK:
        //assign Daylist to const
        //console.log("asdasdasd");
        setCTBDays(careTimes.DayList);
        setFocusdate(initDate);
        setBookingMainStatus("CARE_TIME_BOOKING_SUCCESS");
        break;
      case types.CARETIMES_LOAD_FAILED:
        setBookingMainStatus("CARE_TIME_BOOKING_FAILED");
        break;
      default:
        break;
    }
  }, [careTimes.state]);

  //Load next / previous caretimes
  const [reloadStart, setReloadStart] = useState(moment());
  const [reloadingStatus, setReloadingStatus] = useState(false);

  const getNextMonth = useCallback(() => {
    const newEnd = endDate.clone().add(4, "weeks");

    actions.triggerLoadCareTimesNext({
      date: endDate.clone().add(1, "days"),
      date2: newEnd,
    });
    setEndDate(newEnd);
  }, [endDate]);

  const getPrevMonth = useCallback(() => {
    const newStart = startDate.clone().add(-4, "weeks");
    actions.triggerLoadCareTimesPrev({
      date: newStart,
      date2: startDate.clone().add(-1, "days"),
    });

    setStartDate(newStart);
  }, [startDate]);

  //Load CaretimeCalendar quick info // list of holidays, and info if day contains caretime or status (sick/ absence)
  // 3 months past and 18 months into future
  const quick = state.caretimes.Quick;

  const [quickDateStart, setQuickDateStart] = useState(
    moment().add(-2, "years").startOf("month"),
  );
  const [quickDateEnd, setQuickDateEnd] = useState(
    moment().add(3, "years").startOf("month"),
  );

  useEffect(() => {
    if (bookingMainStatus === "INITIAL STATE") {
      actions.triggerLoadCareTimesQuick({
        startDate: quickDateStart.format("yyyy-MM-DD"),
        endDate: quickDateEnd.endOf("month").format("yyyy-MM-DD"),
      });
    }
  }, [bookingMainStatus]);

  useEffect(() => {
    switch (quick.state) {
      case undefined:
        break;
      case types.LOADING_CARETIMES_QUICK:
        break;
      case types.CARETIMES_QUICK_LOAD_OK:
        break;
      case types.CARETIMES_QUICK_LOAD_FAILED:
        break;
      default:
        break;
    }
  }, [quick.state]);

  //check profilepictures state and load pictures if not in state
  const { profilePictures } = state;
  useEffect(() => {
    if (
      profilePictures.state !== "LOAD_SUCCESS_PROFILEPICTURES" &&
      profilePictures.state !== "LOADING_PROFILEPICTURES"
    ) {
      actions.triggerLoadProfilePictures();
    }
  }, []);

  // load default nursingtimes
  useEffect(() => {
    actions.triggerLoadDefaultNursingTimes();
  }, []);

  // Load clocktype
  useEffect(() => {
    actions.triggerLoadClockType();
  }, []);

  //Save new caretimes

  const saved = state.caretimes.CTSaved;

  useEffect(() => {
    switch (saved.state) {
      case undefined:
        break;
      case types.SAVING_CARETIMES:
        break;
      case types.CARETIMES_SAVED_OK:
        setCTBDays(careTimes.DayList);
        setFocusdate(initDate);
        break;
      case types.CARETIMES_SAVED_WITH_WARNINGS:
        setCTBDays(careTimes.DayList);
        setFocusdate(initDate);
        break;
      case types.CARETIMES_SAVED_FAILED:
        break;
      default:
        break;
    }
  }, [saved.state]);

  useEffect(() => {
    switch (state.caretimes.Deleted.state) {
      case types.CARETIMES_DELETED_OK:
        setCTBDays(careTimes.DayList);
        setFocusdate(initDate);
        break;
      case types.DELETING_CARETIMES:
        break;
      case types.CARETIMES_DELETED_FAILED:
        break;
      default:
        break;
    }
  }, [state.caretimes.Deleted.state]);

  useEffect(() => {
    switch (state.caretimes.Absent.state) {
      case types.CARETIMES_ABSENT_SAVED_OK:
        setCTBDays(careTimes.DayList);
        setFocusdate(initDate);
        break;
      case types.SAVING_CARETIMES_ABSENT:
        break;
      case types.CARETIMES_ABSENT_SAVED_FAILED:
        break;
      default:
        break;
    }
  }, [state.caretimes.Absent.state]);

  //---Overtime---
  const overtime = state.caretimes.Overtime;

  const [isOvertime, setIsOvertime] = useState(false);

  //Overtime use effects
  useEffect(() => {
    if (bookingMainStatus === "INITIAL STATE") {
      actions.triggerLoadOvertime();
    }
  }, [bookingMainStatus]);

  useEffect(() => {
    if (saved.state === types.CARETIMES_SAVED_OK) {
      actions.triggerLoadOvertime();
    }
  }, [saved.state]);

  useEffect(() => {
    if (state.caretimes.Deleted.state === types.CARETIMES_DELETED_OK) {
      actions.triggerLoadOvertime();
    }
  }, [state.caretimes.Deleted.state]);

  useEffect(() => {
    switch (overtime.state) {
      case undefined:
        break;
      case types.CHECKING_OVERTIME:
        break;
      case types.ASYNC_OVERTIME_CHECK_OK:
        setIsOvertime(overtime.overtimeData);
        break;
      default:
        break;
    }
  }, [overtime]);

  let mainViewStatus = bookingMainStatus;

  if (mainViewStatus === "CARE_TIME_BOOKING_SUCCESS") {
    return (
      <>
        <CareTimeCalendarSuccess
          CTBDays={CTBDays}
          focusdate={focusdate}
          handleCalendarNavClick={handleCalendarNavClick}
          getNextMonth={getNextMonth}
          getPrevMonth={getPrevMonth}
          handleFocusDay={handleFocusDay}
          overTime={isOvertime}
        />
      </>
    );
  } else if (mainViewStatus === "CARE_TIME_BOOKING_LOADING") {
    return (
      <>
        <CareTimeCalendarLoading />
      </>
    );
  } else if (mainViewStatus === "CARE_TIME_BOOKING_FAILED") {
    return (
      <>
        <CareTimeCalendarFailed errorCode="404" />
      </>
    );
  } else {
    return (
      <>
        <CareTimeCalendarFailed errorCode="404" />
      </>
    );
  }
};
export default CareTimeCalendar;
